export default __webpack_public_path__ + "AreaChart.png";